export default __webpack_public_path__ + "static/media/stspeterandpaul.9c0c9bd8.jpg";